<template>
  <div class="">
    <template v-if="type !== 2 && !(goodsTypeList && goodsTypeList.length)">
      <el-alert type="error" title="请先在'基本信息'栏选择【可走货物类型】" />
    </template>
    <template v-else>
      <!--<br/>-->
      <div class="box-item">
        <div class="box-item--label">分区类型</div>
        <div class="box-item--content">
          <el-select
            :value="regionType"
            size="small"
            disabled
            class="edit-form__input"
            placeholder="请选择"
            :disabled="disabled"
          >
            <el-option
              v-for="(item, index) in regionTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <el-link
        type="primary"
        @click="addRegionItem"
        :disabled="!canSelectSubareaTotalList.length"
        :underline="false"
        v-if="visibleAddedBtn"
        style="margin-top: 6px"
      >
        <div style="display: flex; align-items: center; line-height: 1">
          <img
            :src="ossPath + '/pages/supplierSystem/quote/icon_add.png'"
            alt="添加"
            style="margin-right: 3px"
          />
          增加分区
        </div>
      </el-link>
      <template v-for="(item, index) in list">
        <div class="box-card">
          <div class="box-item FormWrap">
            <div class="box-item--label">
              分区名称{{ index < 9 ? "0" + (index + 1) : index + 1 }}
            </div>
            <div class="box-item--content">
              <el-input
                v-model="item.regionName"
                @change="(val) => changeRegionName(val, item, index)"
                size="small"
                class="edit-form__input"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </div>
          </div>
          <div class="remove" v-if="list.length > 1">
            <el-link
              type="danger"
              @click="removeRegionItem(index)"
              :underline="false"
              style="margin-top: 6px"
              :key="index"
              :disabled="disabled"
            >
              <el-icon class="el-icon-delete"></el-icon>移除</el-link>
          </div>
          <br />
          <div class="box-item">
            <div class="box-item--label is-required" style="width: 93px">
              分区信息
            </div>
            <div class="box-item--content">
              <el-button
                size="small"
                class="edit-form__input"
                type="primary"
                plain
                @click="showSelectRegion(item, index)"
                :disabled="disabled">
                点击选择分区
              </el-button>
              <span style="font-size: 12px; color: #999; margin-left: 10px"
                >已选 {{ item.regionDetailList.length }} 条</span
              >
              <!--            <el-select v-model="item.regionDetailList"-->
              <!--                       @change="val=>changeRegionDetail(val,item,index)"-->
              <!--                       value-key="warehouseId"-->
              <!--                       class="edit-form__input"-->
              <!--                       size="small"-->
              <!--                       multiple-->
              <!--                       filterable-->
              <!--                       placeholder="请选择">-->
              <!--              <el-option-->
              <!--                v-for="item in canSelectSubareaList[index]"-->
              <!--                :key="item.warehouseId"-->
              <!--                :label="item.namec"-->
              <!--                :value="item">-->
              <!--              </el-option>-->
              <!--            </el-select>-->
            </div>
          </div>
          <br />
          <div class="box-item" v-if="!isSegment || type === 1">
            <div class="box-item--label" style="width: 93px">拆柜城市</div>
            <div class="box-item--content">
              <el-select
                v-model="item.dismantlingCityId"
                @change="(val) => changeDismantlingCity(val, item, index)"
                clearable
                filterable
                class="edit-form__input"
                size="small"
                placeholder="请选择"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in cgCityList"
                  :key="item.id"
                  :label="item.namec"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <!--<el-tag class="index" size="mini">{{priceDetailIndex+1}}</el-tag>-->
            </div>
          </div>
          <div
            v-for="(priceDetailItem, priceDetailIndex) in item.priceDetailList"
            :key="priceDetailItem._id"
            class="goods-type-box goods-card"
          >
            <template v-if="openCustomGoodsType">
              <div class="box-item">
                <div class="box-item--label">可走货物类型</div>
                <div class="box-item--content">
                  <!--支持删除货物类型:disabled="!isSupportMultiGoodsTypePrice"-->
                  <el-select
                    v-model="priceDetailItem.goodsTypeList"
                    value-key="id"
                    multiple
                    filterable
                    class="edit-form__input"
                    size="small"
                    style="width: 646px"
                    placeholder="请选择"
                    :disabled="disabled"
                  >
                    <el-option
                      v-for="item in filterUnselectedList(
                        goodsTypeList,
                        regionAlreadySelectGoodsTypeList[index],
                        priceDetailItem.goodsTypeList,
                        'id'
                      )"
                      :key="item.id"
                      :label="`${item.goodsTypeName}(${item.countryName})`"
                      :value="item"
                      :disabled="
                        goodsTypeDisabled(regionType, item.countryId, index)
                      "
                    >
                    </el-option>
                  </el-select>
                  <!--<el-tag class="index" size="mini">{{priceDetailIndex+1}}</el-tag>-->
                </div>
              </div>
              <div v-if="isSupportMultiGoodsTypePrice" class="remove-content">
                <el-link
                  type="primary"
                  @click="addGoodsTypeRow(item.priceDetailList)"
                  :underline="false"
                  v-if="priceDetailIndex === 0"
                  style="margin-top: 6px"
                  :disabled="disabled"
                >
                  <div
                    style="display: flex; align-items: center; line-height: 1"
                  >
                    <img
                      :src="
                        ossPath + '/pages/supplierSystem/quote/icon_add.png'
                      "
                      alt=""
                      style="margin-right: 3px"
                    />
                    增加可走货物类型
                  </div>
                </el-link>
                <el-link
                  type="danger"
                  @click="
                    removeGoodsTypeRow(item.priceDetailList, priceDetailIndex)
                  "
                  :underline="false"
                  v-else
                  style="margin-top: 6px; margin-right: 10px; color: #ff4d01"
                  :disabled="disabled"
                >
                  <el-icon class="el-icon-delete"></el-icon>
                  移除
                </el-link>
              </div>
            </template>

            <template v-if="isShowRatioSetting">
              <div class="box-item">
                <div class="box-item--label" style="width: 106px">计费单位</div>
                <div class="box-item--content">
                  <el-input
                    disabled
                    v-model="chargeType"
                    class="edit-form__input"
                    :disabled="disabled"
                  ></el-input>
                </div>
                <template v-if="chargeType.toLowerCase() === 'kg'">
                  <div class="box-item--label" style="width: 106px">
                    体积重比率
                  </div>
                  <div class="box-item--content">
                    <el-select
                      v-model="priceDetailItem.volumeWeightRatio"
                      size="small"
                      class="edit-form__input"
                      :disabled="disabled"
                    >
                      <el-option
                        v-for="item in volumeToWeightRatioArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
                <template v-else>
                  <div class="box-item--label" style="width: 106px">
                    重量转换
                  </div>
                  <div class="box-item--content">
                    <el-select
                      v-model="priceDetailItem.weightVolumeRatio"
                      size="small"
                      class="edit-form__input"
                      :disabled="disabled"
                    >
                      <el-option
                        v-for="item in weightVolumeRatioArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </div>
              <br />
            </template>

            <div class="box-item">
              <div class="box-item--label">是否支持单询</div>
              <div class="box-item--content">
                <!--<el-radio-group
                  v-model="priceDetailItem.isNeedInquiry"
                  @input="value=>changeIsNeedInquiry(value,priceDetailItem,priceDetailIndex)"
                  :disabled="priceDetailItem.exemptionType === 2"
                  size="small"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>-->
                <el-select
                  v-model="priceDetailItem.isNeedInquiry"
                  :disabled="priceDetailItem.exemptionType === 2 || disabled"
                  @change="
                    (value) =>
                      changeIsNeedInquiry(
                        value,
                        priceDetailItem,
                        priceDetailIndex
                      )
                  "
                  class="edit-form__input"
                  size="small"
                >
                  <el-option :value="true" label="是">是</el-option>
                  <el-option :value="false" label="否">否</el-option>
                </el-select>
              </div>
            </div>
            <template v-if="isSupportMultiChannel">
              <div class="box-item">
                <div class="box-item--label" style="width: 170px">
                  专线api对接渠道代码
                </div>
                <div class="box-item--content">
                  <!--                <el-input v-model="priceDetailItem.channelCode"-->
                  <!--                          size="small"-->
                  <!--                          class="edit-form__input"-->
                  <!--                          placeholder="请输入"></el-input>-->
                  <select-api-channel-code
                    v-model="priceDetailItem.channelCode"
                    :can-get="canGetChannelCode"
                    :loading="apiChannelCodeListLoading"
                    :status="apiChannelCodeListGetStatus"
                    :list="apiChannelCodeList"
                    :time-out-number="apiChannelCodeRequestSpace"
                    @clickBtn="(val) => $emit('clickGetApiChannelCode', val)"
                    size="small"
                    class="api-channel-code"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <br />
      <div class="box-item" v-if="canSelectSubareaTotalList.length">
        <!--        <div class="box-item&#45;&#45;label"></div>-->
        <div class="box-item--content">
          <el-popover
            placement="top-start"
            :title="`未选分区(共：${canSelectSubareaTotalList.length} 条)：`"
            width="640"
            trigger="hover"
          >
            <div slot="reference" class="not-select-region">
              未选：
              <template v-if="canSelectSubareaTotalList.length > 20">
                {{
                  joinRegionItemName(canSelectSubareaTotalList.slice(0, 20))
                }}....
              </template>
              <template v-else>
                {{ joinRegionItemName(canSelectSubareaTotalList) }}
              </template>
            </div>
            <div
              style="line-height: 2; max-height: 500px; overflow: hidden auto"
            >
              {{ joinRegionItemName(canSelectSubareaTotalList) }}
            </div>
          </el-popover>
        </div>
      </div>
    </template>
    <select-region
      :visible.sync="visibleSelectRegion"
      :default-list="currentRegionList"
      :default-select="currentSelectValue"
      :regionType="regionType"
      :is-segment="isSegment"
      :type="type"
      :region-list="list"
      :regionIndex="currentRegionIndex"
      @select="changeRegionSelect"
      @closed="hideSelectRegion"
    />
  </div>
</template>

<script>
import { rulesNotEmpty } from "@/assets/js/formRules";
import {
  baseDataPriceDetailItem,
  baseDataPriceDetailPriceItem,
  baseDataRegionHeaderItem,
} from "@/components/QuotationManagement/components-productQuotation/productQuotation";
import { isArray, isObject } from "my-tools-kit";
import { filterUnselectedList } from "@/components/QuotationManagement/components-productQuotation/filterUnselectedList/utils";
import { createRegionHeaderItem } from "@/components/QuotationManagement/components-productQuotation/freightPrice";
import SelectRegion from "@/components/QuotationManagement/components-productQuotation/selectRegion";
import SelectApiChannelCode from "@/components/QuotationManagement/components-productQuotation/selectApiChannelCode";
import { weightVolumeRatioArray, volumeToWeightRatioArray } from "../baseInfo";

let regionTypeArray = [
  { label: "邮编", value: 1 },
  { label: "国家", value: 2 },
  { label: "城市", value: 3 },
  { label: "仓库编码", value: 4 },
  { label: "邮编分区", value: 5 },
  { label: "多国家分区", value: 6 },
];
let timeTypeArray = [
  { label: "工作日", value: 1 },
  { label: "自然日", value: 2 },
];
export default {
  name: "cityRegionNameAndSelect",
  components: { SelectApiChannelCode, SelectRegion },
  props: {
    regionType: [String, Number],
    list: {
      //分区列表
      type: Array,
      default: () => [],
    },
    tableHeadList: {
      //表头列表(价格区间)
      type: Array,
      default: () => [],
    },
    subareaList: {
      //目的地列表(分区信息列表)
      type: Array,
      default: () => [],
    },
    cgCityList: {
      //拆柜城市列表
      type: Array,
      default: () => [],
    },
    chargeType: [String, Number], // 计费方式 通过 "物流产品详情"或"报价详情"接口获取
    visibleAddedBtn: {
      //展示新增分区按钮
      type: Boolean,
      default: true,
    },
    isSegment: Boolean, //是否是分段报价
    type: {
      // 分段类型 1：全包(头程) 2:派送
      type: Number,
      default: 1,
    },
    globalChannelCode: String, //非多渠道时的全局专线api对接渠道代码
    isSupportMultiChannel: Boolean, //是否多渠道
    openCustomGoodsType: {
      type: Boolean,
      default: true,
    }, //支持编辑货物类型
    isSupportMultiGoodsTypePrice: Number, //是否支持多产品分类报价 0>false 1>true
    goodsTypeList: {
      //供选择的货物类型列表
      type: Array,
      default: [],
    },

    // 供应商编辑里是否勾选了是否可获取到专线API对接渠道代码
    canGetChannelCode: {
      type: Boolean,
      default: null,
    },
    // 专线api对接渠道代码列表 是否正在请求中
    apiChannelCodeListLoading: {
      type: Boolean,
      default: false,
    },
    // 专线api对接渠道代码列表 请求间隔(倒计时)
    apiChannelCodeRequestSpace: {
      type: Number,
      default: 0,
    },
    // 专线api对接渠道代码列表 获取状态  0-未请求  1-请求成功 2-请求失败
    apiChannelCodeListGetStatus: {
      type: Number,
      default: 0,
    },
    // 专线api对接渠道代码列表
    apiChannelCodeList: {
      type: Array,
      default: () => [],
    },
    isShowRatioSetting: false,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      /* 表单校验 */
      formRules: {
        no: [{ trigger: "blur", required: false }],
        require: [rulesNotEmpty()],
      },
      // 分区类型
      regionTypeList: regionTypeArray,

      // 选择分区
      visibleSelectRegion: false,
      currentRegionIndex: -1,
      // 当前分区 可选分区列表
      currentRegionList: [],
      // 当前分区 已选分区列表
      currentSelectValue: [],

      // 所有 已选 分区总计
      alreadySelectSubareaList: [],
      // 所有 可选 分区总计
      canSelectSubareaTotalList: [],
      weightVolumeRatioArray,
      volumeToWeightRatioArray,
    };
  },
  computed: {
    /**
     * 已经选中的列表 [String|number]
     * */
    // alreadySelectSubareaList(){
    //   let alreadySelect = [];
    //   this.list.forEach(res=>alreadySelect.push(...(res.regionDetailList || [])));
    //   return alreadySelect;
    // },
    /**
     * 可选分区列表 [Object]
     * */
    // canSelectSubareaTotalList(){
    //   // return this.subareaList
    //   return this.subareaList.filter(res=>{
    //     return !this.alreadySelectSubareaList.find(item=>item.warehouseId === res.warehouseId);
    //   });
    // },
    /**
     * 对应分区可选的列表
     */
    // canSelectSubareaList(){
    //   // return [];
    //   let valueList = this.canSelectSubareaTotalList.map(res=>res.warehouseId);
    //   return this.list.map(res=>{
    //     return this.subareaList.filter(item=>{
    //       let alreadySelectValue = res.regionDetailList || [];
    //       alreadySelectValue = alreadySelectValue.map(res=>res.warehouseId);
    //       return alreadySelectValue.includes(item.warehouseId) || valueList.includes(item.warehouseId);
    //     });
    //   })
    // },
    /**
     * 按分区维度统计分区下已选择的 可走货物类型
     */
    regionAlreadySelectGoodsTypeList() {
      return this.list.map((regionItem) => {
        let arr = [];
        regionItem.priceDetailList.forEach((item) =>
          arr.push(...item.goodsTypeList)
        );
        return arr;
      });
    },
    /**
     * 需要计算所有可选
     */
    needCountCanSelectTotal() {},
  },
  watch: {
    list: {
      immediate: false,
      handler(val) {
        console.log("分区组件 watch list");
        this.getTotalCanSelectSubareaList();
      },
    },
    subareaList: {
      immediate: false,
      handler(val) {
        console.log("分区组件 watch subareaList");
        this.getTotalCanSelectSubareaList();
      },
    },
  },
  methods: {
    filterUnselectedList,
    /**
     * 新增分区
     */
    addRegionItem() {
      let defaultDeliveryRegion = createRegionHeaderItem({
        regionType: this.regionType, //分区类型
        type: this.type || 1, //分段类型 1：全包(头程) 2:派送
        chargeType: this.chargeType, //计费方式: CBM:体积 KG:重量
        isSupportMultiGoodsTypePrice: this.isSupportMultiGoodsTypePrice, //是否支持多产品分类报价 0>false 1>true
        tableHeadList: this.tableHeadList || [], //价格区间
        goodsTypeList: this.regionType === 6 ? [] : this.goodsTypeList || [], //可走货物类型
        channelCode: this.isSupportMultiChannel ? "" : this.globalChannelCode, //填充专线api对接渠道代码
      });

      this.list.push(defaultDeliveryRegion);
      this.$emit("addedRegion");
    },
    newRegionItem() {
      let data = baseDataRegionHeaderItem();
      let tableHeadList = this.tableHeadList || [];
      let firstItem = tableHeadList[0] || {};
      Object.assign(data, {
        regionType: this.regionType, //分区类型
        type: this.type || 1, //分段类型 1：全包(头程) 2:派送
        dispatchId: firstItem.dispatchId, //关联派送区间id
        chargeType: this.chargeType, //计费方式: CBM:体积 KG:重量
      });
      let goodsTypeList = [];
      if (!this.isSupportMultiGoodsTypePrice)
        goodsTypeList.push(...this.goodsTypeList);
      let priceList = tableHeadList.map((res) => {
        if (!(res instanceof Object)) res = {};
        return Object.assign(baseDataPriceDetailPriceItem(), {
          chargeSectionDetailId: res.chargeSectionDetailId, // 分区区间id
          sectionStartNum: res.start, // 区间开始值
          sectionEndNum: res.end, // 区间结束值
        });
      });
      let priceDetailItem = Object.assign(baseDataPriceDetailItem(), {
        goodsTypeList,
        priceList,
      });
      data.priceDetailList.push(priceDetailItem);
      console.log(priceDetailItem);
      return data;
    },
    /**
     * 移除 分区item
     */
    removeRegionItem(index = 1) {
      this.list.splice(index, 1);
      this.$emit("removeRegion");
    },
    /**
     * 改变值：是否支持单询
     */
    changeIsNeedInquiry(value, item, index) {
      if (value) {
        if (isArray(item.priceList))
          item.priceList.forEach((item) => (item.price = 0));
      } else {
        if (isArray(item.priceList)) {
          item.priceList.forEach((item) => {
            console.log("i", item);
            if (
              this.type === 1 &&
              !this.tableHeadList[0].supportRenewal &&
              item.sectionStartNum === 0
            ) {
              item.price = "0";
            } else {
              item.price = "";
            }
          });
        }
      }
      // if(value && isArray(item.priceDetailList) && item.priceDetailList.length){
      //   item.colspan = item.priceDetailList.length;
      // }else {
      //   item.colspan = 1;
      // }
    },
    /**
     * 增加 可走货物类型方案
     */
    addGoodsTypeRow(priceDetailList) {
      let tableHeadList = this.tableHeadList || [];
      let goodsTypeList = [];
      let priceList = tableHeadList.map((res) => {
        if (!(res instanceof Object)) res = {};
        return Object.assign(baseDataPriceDetailPriceItem(), {
          chargeSectionDetailId: res.chargeSectionDetailId, // 分区区间id
          sectionStartNum: res.start, // 区间开始值
          sectionEndNum: res.end, // 区间结束值
        });
      });
      let channelCode =
        priceDetailList && priceDetailList.length
          ? priceDetailList[0].channelCode
          : "";
      let priceDetailItem = Object.assign(baseDataPriceDetailItem(), {
        goodsTypeList,
        priceList,
        channelCode,
      });
      priceDetailList.push(priceDetailItem);
      console.log(priceDetailItem);
      this.$emit("addedPricePlan");
    },
    /**
     * 移除可走货物类型
     * @param priceDetailList
     * @param priceDetailIndex
     */
    removeGoodsTypeRow(priceDetailList, priceDetailIndex) {
      priceDetailList.splice(priceDetailIndex, 1);
      this.$emit("removePricePlan");
    },
    /**
     * 编辑 分区名称
     */
    changeRegionName(val, regionItem, regionIndex) {
      this.$emit("changeRegionName", val, regionItem);
    },
    /**
     * 改变 分区信息列表的选择
     */
    changeRegionDetail(val, regionItem, regionIndex) {
      this.$emit("changeRegionDetailList", val, regionItem, regionIndex);
    },
    /**
     * 显示 选择分区 弹窗
     */
    showSelectRegion(item, index) {
      let selectValue = item.regionDetailList || [];
      // let allList = this.canSelectSubareaList[index]||[];
      let allList = this.canSelectSubareaTotalList || [];
      this.currentRegionList = allList;
      this.currentSelectValue = selectValue;
      this.visibleSelectRegion = true;
      this.currentRegionIndex = index;
    },
    hideSelectRegion() {
      console.log("hideSelectRegion");
      this.currentRegionList = [];
      this.currentSelectValue = [];
      this.visibleSelectRegion = false;
      this.currentRegionIndex = -1;
    },
    changeRegionSelect(selectValue = []) {
      console.log("changeRegionSelect", selectValue);
      let regionIndex = this.currentRegionIndex;
      if (regionIndex < 0) return false;
      let regionItem = this.list[regionIndex];
      if (!isObject(regionItem)) return false;
      regionItem.regionDetailList = selectValue;
      this.getTotalCanSelectSubareaList();
      this.changeRegionDetail(selectValue, regionItem, regionIndex);
      // 多国家分区则过滤除国家支持的货物类型
      if (this.regionType === 6) {
        let countryGoodsTypeList = [];
        this.goodsTypeList.forEach((item) => {
          let isCountryGoodType =
            selectValue.findIndex((e) => +e.warehouseId === item.countryId) >
            -1;
          if (isCountryGoodType) {
            countryGoodsTypeList.push(item);
          }
        });
        if (!countryGoodsTypeList.length)
          return this.$message(
            "基本信息-可走货物类型，没有当前所选国家的货物类型，请添加"
          );
        this.$set(
          this.list[this.currentRegionIndex].priceDetailList[0],
          "goodsTypeList",
          countryGoodsTypeList
        );
      }
    },
    /**
     * 拼接未选文本
     * @param list
     * @returns {string}
     */
    joinRegionItemName(list = []) {
      return list.map((item) => item.namec).join(",");
    },
    /** 计算所有可选 */
    getTotalCanSelectSubareaList() {
      console.log("计算所有可选", this.list.length, this.subareaList.length);
      // 已选
      let alreadySelect = [];
      this.list.forEach((res) => {
        let arr = res.regionDetailList || [];
        // alreadySelect.push(...arr);
        arr.forEach((item) => alreadySelect.push(item.warehouseId));
      });
      // 可选
      let canSelect = this.subareaList.filter((item) => {
        return !alreadySelect.includes(item.warehouseId);
      });
      this.canSelectSubareaTotalList = canSelect;
    },
    /**
     * 选择拆柜城市
     */
    changeDismantlingCity(value, regionItem, regionIndex) {
      console.log("选择拆柜城市", value);
      let cgCityItem = this.cgCityList.find((item) => item.id === value);
      if (cgCityItem) {
        regionItem.dismantlingCityName = cgCityItem.namec || "";
      } else {
        regionItem.dismantlingCityName = "";
      }
      this.$emit("changeDismantlingCity", value, regionItem);
    },
    /**
     * 货物类型支持的国家与当前分区国家不同则禁用
     * @param {*} regionType
     * @param {*} countryId
     * @param {*} index
     */
    goodsTypeDisabled(regionType, countryId, index) {
      if (regionType !== 6) return false;
      let regionItem = this.list[index];
      if (!regionItem) return false;
      let countryList = regionItem.regionDetailList;
      if (!countryList) return false;
      if (!countryList.length) return false;
      let regionCountryId = countryList[0].warehouseId;
      return countryId != regionCountryId;
    },
  },
  mounted() {
    console.log("分区组件 mounted");
    this.getTotalCanSelectSubareaList();
  },
};
</script>

<style scoped lang="scss">
@import "../boxItem";
.box-card {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 12px;
  position: relative;
  &:not(:first-child) {
    margin-top: 20px;
  }
  .remove {
    width: 81px;
    height: 30px;
    box-sizing: border-box;
    padding-left: 15px;
    background: #fcede7;
    border-radius: 0 12px 0 12px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .goods-card {
    margin-top: 10px;
    padding: 10px 20px 0;
    background: #f3f3f3;
    border-radius: 6px;
    position: relative;
    .remove-content {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.not-select-region {
  display: block;
  height: 30px;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 4px;
  background: #fff6f3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #ff4d01;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/regionNameAndSelect/cityRegionNameAndSelect.vue